// @flow
import { lighten, darken } from '@material-ui/core/styles/colorManipulator';

import type { GradientColorStops } from '../types';

export type Config<C: string> = {
  coefficient?: number,
  colorStops?: { [C]: ?string | GradientColorStops },
};

export default function getGradientColorStops<C: string>(
  { coefficient = 0.1, colorStops }: Config<C>,
  color: ?C,
): ?GradientColorStops {
  const colorConfig = (color && colorStops?.[color]) || undefined;

  if (colorConfig && typeof colorConfig === 'string') {
    return [
      lighten(colorConfig, coefficient),
      darken(colorConfig, coefficient),
    ];
  }
  return colorConfig;
}
